<header class="account__setup--header">
  <span class="app__form--attribute--title font-semibold text-base"> Security & Privacy </span>
  <button matTooltipPosition="above" data-dismiss="modal" class="bg-white" (click)="closeSideNav()">
    <span class="material-icons relative bg-white">clear</span>
  </button>
</header>

<section class="flex" [style]="screenWidth > 480 ? 'height: 90vh' : 'margin-bottom: 60px'">
  @if (screenWidth > 480) {
  <div class="nav w-[253px]">
    <nav class="w-full">
      <ul class="w-full pt-5">
        @for (step of steps; track step; let index = $index; let last = $last) {
        <li
          matTooltipPosition="above"
          [matTooltip]="step.disabled ? 'Only the users themselves can access ' + step.title + ' settings' : ''"
          class="app__stepper__config-stepitem"
          [class]="step.completed ? 'hover:text-[#1AA140] cursor-default' : ''"
          [ngClass]="{
            'app__stepper__config-stepitem-completed': step.completed,
            'app__stepper__config-stepitem-notcompleted': !step.completed,
            'app__stepper__config-stepitem-selected  app__network--setup-selected': step.status == 'active',
            'opacity-[0.2]': step.disabled,
            hidden: index == 0 && switchFromUser
          }"
          (click)="!step.disabled ? handleSidenavMenuNavigation(index) : null"
        >
          @if (step.completed) {
          <img class="app__stepper__image-checked" src="../../../../assets/images/check-green.svg" alt="green-check" />
          }
          {{ step.title | titlecase }}
        </li>
        }
      </ul>
    </nav>
  </div>
  }
  <div class="pr-0" [ngClass]="{ 'account__setup--body ': !isImpersonating, 'account__setup-impersonating-body': isImpersonating }">
    <!-- Set Up Two Factor Authentication -->
    <div
      [ngClass]="{
        'h-full flex flex-col justify-between': true
      }"
    >
      <div class="h-[85.5%] max-h-[85.5%] overflow-y-auto">
        @if(currentActiveIndex === 0){
        <instruction-setup
          style="margin-right: 42px; display: block"
          [setupInstructions]="setupInstructions"
          [title]="'Security & Privacy'"
          [videoSrc]="'https://www.loom.com/embed/d4ba93edbe934d4fad760fd16fd13c71?sid=c04f1d12-cea8-4e66-847c-c2c249725ed4'"
        ></instruction-setup>
        } @else if(currentActiveIndex ===3 ){
        <div class="mr-[42px]">
          <div class="rounded-xl min-h-60 w-full border bg-white flex items-center justify-center flex-col py-8 px-12 mt-4">
            <p
              [class]="
                screenWidth > 480
                  ? 'sm:mb-2 text-xl text-center  text-[#53565B] font-semibold'
                  : 'sm:mb-[8px] text-xl leading-5 text-center text-[#53565B] font-semibold'
              "
            >
              Mark
              <span class="font-weight-bold-blue"> Security & Privacy Setup </span>
              as Complete?
            </p>

            <div class="flex mt-1">
              <app-button-slide (isSubmitButtonActiveForSubMit)="submitAllFormAnswers($event)"></app-button-slide>
            </div>
            <div class="app__mark--complete--info">
              <img src="../../../../assets/images/mark-as-complete-info.svg" alt="mark-complete-info" />
              <span class="app__form--attribute--title">
                Marking this as complete will save all the information which has been added. Two factor authentication can be changed in the future
                from 'Settings' and premium keys can be changed in the future from 'Vaults'.
              </span>
            </div>
          </div>
        </div>
        } @else if(currentActiveIndex >= 1 && currentActiveIndex<=3 ){ @for(setup of steps; track $index){ @if(currentActiveIndex === $index ){
        @if(currentActiveIndex == 1){
        <account-security [fromSetup]="true"></account-security>
        } @else if(currentActiveIndex == null){
        <div class="mr-[42px]">
          <div>
            <p class="text-xl text-[#53565B] font-semibold">
              {{ (currentUser?.nick_name ?? currentUser?.first_name) + "'s" | titlecase }}
              <span class="text-k-blue font-bold"> Visibility in Global Search </span>
            </p>
          </div>

          <form #userEditProfileFormDirective="ngForm" [formGroup]="searchVisibilityForm">
            <div class="bg-white rounded-2xl p-6 border">
              <div class="flex justify-between">
                <p class="text-base font-semibold">Search Visibility by <span class="text-k-blue font-bold"> Name </span></p>
                <div class="flex items-center gap-2">
                  <span class="text-[#898F9E] font-semibold">{{ name_search_enabled ? 'ON' : ('OFF' | uppercase) }}</span>
                  <mat-slide-toggle formControlName="name_search_enabled" (change)="onChangeSearch($event, 'name_search_enabled')"></mat-slide-toggle>
                </div>
              </div>
              <p class="text-sm font-normal">Make yourself visible to others when they search for you by name.</p>
            </div>

            <div class="bg-white rounded-2xl p-6 mt-6 border">
              <div class="flex justify-between">
                <p class="text-base font-semibold">Search Visibility by <span class="text-k-blue font-bold"> Email Address </span></p>
                <div class="flex items-center gap-2">
                  <span class="text-[#898F9E] font-semibold">{{ email_search_enabled ? 'ON' : ('OFF' | uppercase) }}</span>
                  <mat-slide-toggle
                    formControlName="email_search_enabled"
                    (change)="onChangeSearch($event, 'email_search_enabled')"
                  ></mat-slide-toggle>
                </div>
              </div>
              <p class="text-sm font-normal">Make yourself visible to others when they search for you by email address.</p>
            </div>
          </form>
        </div>
        } @else if(currentActiveIndex == 2){

        <premium-keys
          [isActiveView]="currentViewOnStep3"
          style="margin-right: 42px; display: block"
          [title]="'Premium Keys'"
          [currentUser]="currentUser"
          (premiumKeysEmitter)="premiumKeysEmitter($event)"
        >
        </premium-keys>
        } } } }
      </div>
      <div class="relative w-full flex flex-col pr-[42px]">
        <mat-divider class="text-[#C1C2C5] w-full"></mat-divider>
        <div
          class="edit__profile-footer-transparent pt-0 items-center px-10"
          [ngClass]="{
            'justify-between': currentActiveIndex > 0
          }"
        >
          @if (currentActiveIndex > 0) {
          <button class="bg-transparent cursor-pointer flex items-center font-bold text-xs gap-2" (click)="gotoPrevious()">
            <span class="flex items-center gap-2 text-[#18191C]"
              ><span class="material-icons text-base font-semibold"> arrow_back</span>
              <span class="text-sm font-semibold"> Back </span>
            </span>
          </button>
          } @if(currentActiveIndex <3){
          <button
            class="app__btn--primary w-fit min-w-[158px] py-3 px-8 mt-5"
            (click)="
              currentActiveIndex === 3 && markAsComplete
                ? completeSetup()
                : currentActiveIndex === 3 && !markAsComplete
                ? closeSideNav()
                : handleSidenavMenuNavigation()
            "
          >
            Continue
          </button>
          }
        </div>
      </div>
    </div>

    @if (showLoader) {
    <div>
      <div class="loading-spinner loader-overlay">
        <!-- <mat-spinner></mat-spinner> -->
      </div>
    </div>
    }
  </div>
</section>
